import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, RouterModule } from '@angular/router';
import bwipjs from '@bwip-js/browser';
// Previous 1D CODE128 barcode — kept commented for now (see the rollback block in printLabels()).
// import JsBarcode from "jsbarcode";

@Component({
    selector: 'app-print-label',
    imports: [RouterModule, CommonModule, MatButtonModule, MatIcon],
    templateUrl: './print-label.component.html',
    styleUrl: './print-label.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class PrintLabelComponent implements OnInit, AfterViewInit {

  pId: any;
  yob: any;
  dos: any;
  oId: any;

  constructor(
    private readonly route: ActivatedRoute
  ){
    
  }

  ngOnInit(): void {
    this.route.queryParams?.subscribe({
      next: (params) => {
        console.log("Query Params in Print Label Component", params);
        this.pId = params['pId'];
        this.yob = params['yob'];
        this.dos = params['dos'];
        this.oId = params['oId'];
      }
    });
  }

  ngAfterViewInit() {
    this.printLabels();
  }

  printLabels() {
    // ---------- Barcode (Data Matrix, 2D) ----------
    // A 2D Data Matrix packs the patient id into a compact square instead of a wide 1D strip,
    // so it fits the 50mm label without overflowing/overlapping. bwip-js renders vector SVG,
    // which stays crisp at the printer's DPI; the physical size is set in the SCSS (.barcode svg).
    // Requires a 2D imaging scanner — 1D laser scanners cannot read Data Matrix.
    const value = String(this.pId ?? '').trim();
    const container = document.getElementById("barcode");
    if (container && value) {
      try {
        container.innerHTML = bwipjs.toSVG({
          bcid: "datamatrix",
          text: value,
          scale: 3,
          padding: 2, // quiet zone — Data Matrix needs a clear margin around it to scan
        });
      } catch (error) {
        console.error("Failed to render Data Matrix barcode", error);
      }
    }

    // ---------- Previous 1D CODE128 barcode — kept commented for now (quick rollback) ----------
    // To restore the 1D barcode: uncomment the JsBarcode import above and the block below, switch
    // the #barcode element back to an <svg> in the template (JsBarcode targets an svg/canvas/img),
    // and drop the fixed 12mm square sizing on `.barcode svg` in the SCSS (that is for the 2D code).
    // JsBarcode("#barcode", this.pId, {
    //   format: "CODE128",
    //   width: 1,           // narrowed from 1.2 to reduce width; drop to 0.9 for longer ids
    //   height: 38,
    //   displayValue: false,
    //   margin: 0,
    // });

    let barcodeLabel = document.getElementById("barcodeLabel");
    if (barcodeLabel) {
      window.print();
    }
  }

  closePrint() {
    window.close();
  }
}